import { isMolfileNotEmpty } from 'nmr-processing';
import { Molecule } from 'openchemlib/full';
export async function readMolfile(file, options = {}) {
    const result = readMolfileText(await file.text());
    if (result.molecules.length === 0) {
        options.logger?.debug(`${file.name} is an empty molfile`);
    }
    return result;
}
export function readMolfileText(originalMolfile) {
    const result = {
        molecules: [],
        spectra: [],
    };
    if (isMolfileNotEmpty(originalMolfile)) {
        const molecule = Molecule.fromMolfile(originalMolfile);
        // it is important to save again the molfile because during this process all the
        // hydrogens are placed at the end of the molfile and we ensure
        // that loading / saving the molfile using openchemlib will not change the order of the atoms
        const molfile = molecule.toMolfile();
        result.molecules.push({ molfile });
    }
    return result;
}
//# sourceMappingURL=readMolfile.js.map